import React, { useState } from "react";

import config from "../../config/app";
import TextInput from "./TextInput";
import SiteService from "../../service/SiteService.mjs";
import { getSiteKey } from "../../hooks/query/useSite";
import {
  setDesignVersionOverride,
  getDesignVersionOverride,
  removeDesignVersionOverride,
} from "../../utils/DesignVersionUtils";
import { MIGRATION_TYPE_PREVIEW } from "../../constants/MigrationConstants";

const DATA_PREVIEW_SUBDIR = "preview";

const MigrationOptions = () => {
  const [dataModelVersion, setDataModelVersion] = useState(
    config.dataModelVersion
  );
  const [showPreviewUrl, setShowPreviewUrl] = useState(false);
  const siteKey = getSiteKey();

  const onSetRequestDataModelVersion = () => {
    setDesignVersionOverride(dataModelVersion);
    window.location.reload();
  };

  const onClearDataOverride = () => {
    removeDesignVersionOverride();
    window.location.reload();
  };

  const onPreviewDataMigration = () => {
    const key = getSiteKey();
    SiteService.migrateDesign({
      key,
      migrationType: MIGRATION_TYPE_PREVIEW,
      requestedVersion: dataModelVersion,
    }).then(() => setShowPreviewUrl(true));
  };

  return (
    <div className="migration-options">
      <div className={"renderer-preview-header"}>
        <label style={{ color: "var(--text-base-primary)" }}>Design Data Version</label>
      </div>
      <TextInput
        label={"Data Model Version"}
        value={dataModelVersion}
        width={"80%"}
        onChange={setDataModelVersion}
        placeholder={"Data Model Version"}
      />
      <button
        onClick={onSetRequestDataModelVersion}
        style={{ marginBottom: "15px", marginRight: "15px" }}
        className="si-c-btn si-c-btn--primary"
      >
        Change Data Model Version
      </button>
      {getDesignVersionOverride() !== null && (
        <button
          onClick={onClearDataOverride}
          style={{ marginBottom: "15px" }}
          className="si-c-btn si-c-btn--danger"
        >
          Clear Data Version Override
        </button>
      )}
      <br />
      <button
        onClick={onPreviewDataMigration}
        style={{ marginBottom: "15px", marginRight: "15px" }}
        className="si-c-btn si-c-btn--primary"
      >
        Preview Data Migration
      </button>
      {showPreviewUrl && (
        <div style={{ marginBottom: "15px" }}>
          <a
            href={`${config.awsURL}/${config.designsBucket}/${siteKey}/${DATA_PREVIEW_SUBDIR}/site.json`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Preview JSON
          </a>
        </div>
      )}
      <br />
    </div>
  );
};

export default MigrationOptions;
